module.exports = __webpack_public_path__ + "img/poster-05.0c626558.png";